// Code generated by protoc-gen-zeroapi. DO NOT EDIT.

import service from '@/lobby_common/utils/request'

// 获取服务域名
// Req : open_proto.client.v1.resource.GetServiceDomainReq
// Resp: open_proto.client.v1.resource.GetServiceDomainResp
export const getServiceDomain = (data) => {
  return service({
    url: '/v1/resource/serviceDomain',
    method: 'post',
    data
  })
}
// 获取资源
// Req : open_proto.client.v1.resource.GetResourceRequest
// Resp: open_proto.client.v1.resource.GetResourceResponse
export const getResource = (data) => {
  return service({
    url: '/v1/resource/getResource',
    method: 'post',
    data
  })
}
// 获取包版本信息
// Req : open_proto.client.v1.resource.GetPacketVersionReq
// Resp: open_proto.client.v1.resource.PacketVersionResp
export const getPacketVersion = (data) => {
  return service({
    url: '/v1/resource/getPacketVersion',
    method: 'post',
    data
  })
}
// 获取事件上报配置
// Req : open_proto.client.v1.resource.GetAdsEventsReq
// Resp: open_proto.client.v1.resource.GetAdsEventsResp
export const getAdsEvents = (data) => {
  return service({
    url: '/v1/resource/getAdsEvents',
    method: 'post',
    data
  })
}
// 获取配置
// Req : open_proto.client.v1.resource.GetConfReq
// Resp: open_proto.client.v1.resource.GetConfResp
export const getConf = (data) => {
  return service({
    url: '/v1/resource/getConf',
    method: 'post',
    data
  })
}
// 获取配置
// Req : open_proto.client.v1.resource.GetConfReq
// Resp: open_proto.client.v1.resource.StaticTpl
export const getStaticTpl = (data) => {
  return service({
    url: '/v1/resource/getStaticTpl',
    method: 'post',
    data
  })
}
// 获取应用提示信息
// Req : open_proto.client.v1.resource.GetAppPromptInfoReq
// Resp: open_proto.client.v1.resource.GetAppPromptInfoResp
export const getAppPromptInfo = (data) => {
  return service({
    url: '/v1/resource/getAppPromptInfo',
    method: 'post',
    data
  })
}
